import isEmptyObject from 'lodash.isempty';

export default function isEmpty(val: any): boolean {
  if (val == null) {
    return true;
  }

  if (typeof val === 'object') {
    return isEmptyObject(val);
  }

  if (typeof val === 'string') {
    return val.trim() === '';
  }

  return false;
}
